const LevelLearning = () => {
  return <div className="text-blue-500">Level Learning</div>;
};
export default LevelLearning;
